import {useEffect, useState} from 'react';
import { useAuthContext } from '../../hooks/useAuthContext';
import axios from 'axios';

const UpdateProfile = () => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [businessName, setBusinessName] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const {user} = useAuthContext(); //grabbing the user object that is returned from the useAuthContext hook
    
    //get user id from the user object that is returned from the AuthContext
    const userId = user.userId;

    //get ahold of user info including email, name, number, business name
    useEffect(() => {
        const getUserInfo = async () => {
            const response = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/api/user/get-user-info/${userId}`
            )
            const userInfo = response.data.userInfo;
            setEmail(userInfo.email);
            setFirstName(userInfo.firstName);
            setLastName(userInfo.lastName);
            setBusinessName(userInfo.businessName);
            setPhoneNumber(userInfo.phoneNumber);
        }

        if (user) {
            getUserInfo();
        }
    }, [user, userId])


    //function to update user info in the DB through a POST request
    const editUserInfo = async (e) => {
        e.preventDefault();
        setSuccessMessage('Profile Updated');

        try {
            await axios.patch(
                `${process.env.REACT_APP_SERVER_URL}/api/user/update-user-info`,
                {userId, firstName, lastName, businessName, phoneNumber}
            )
        } catch (e) {
            console.log(e.response.data.error);
            setError(e.response.data.error);
        }

        setTimeout(() => setSuccessMessage(""), 3000); // Clears the message after 3 seconds
    }



    //return an html form that is only editable if the user clicks the edit button
    return (
        <form className="modal-form" onSubmit={editUserInfo}>
            <div className="inputs-container">
                <div className="inner-form-container">
                    <label className="form-label">Email</label>
                    <p>{email}</p>
                </div>
                <div className="inner-form-container">
                    <label className="form-label">First Name</label>
                    <input 
                        className="form-control"
                        type="text"
                        onChange={(event) => setFirstName(event.target.value)}
                        value={firstName} 
                    />
                </div>
                <div className="inner-form-container">
                    <label className="form-label">Last Name</label>
                    <input 
                        className="form-control"
                        type="text"
                        onChange={(event) => setLastName(event.target.value)}
                        value={lastName} 
                    />
                </div>
                <div className="inner-form-container">
                    <label className="form-label">Business Name</label>
                    <input 
                        className="form-control"
                        type="text"
                        onChange={(event) => setBusinessName(event.target.value)}
                        value={businessName} 
                    />
                </div>
                <div className="inner-form-container">
                    <label className="form-label">Phone</label>
                    <input 
                        className="form-control"
                        type="tel"
                        onChange={(event) => setPhoneNumber(event.target.value)}
                        value={phoneNumber} 
                    />
                </div>
            </div>

            <button type="submit" className="btn btn-light">Update</button>
            {successMessage && <p style={{color: "green"}}>{successMessage}</p>}
            {error && <div className="error">{error}</div>}
        </form>
    )
}


export default UpdateProfile;

